import { Typography } from "@mui/material";
import { useStyles } from "../RCACompliance.styles";
import { RCACorporateDashboardEntity } from "entities/RCA/RCACorporateDashboardEntity/RCACorporateDashboardEntity";
import { IAvgActionPlansPerMill } from "entities/RCA/RCACorporateDashboardEntity/RCACorporateDashboardEntityInterfaces";
import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { RCACorporateDashboardContext } from "contexts/RCACorporateDashboardContext/RCACorporateDashboardContext";
import RCAWithNoActionPlansByMillModal from "./RCAWithNoActionPlansByMillModal";

const RCAActionPlansPerMill = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { filters } = useContext(RCACorporateDashboardContext);
    const [totalAvg, setTotalAvg] = useState(0);
    const [totalRcaWithZeroAP, setTotalRcaWithZeroAP] = useState(0);
    const [millSelected, setMillSelected] = useState<IAvgActionPlansPerMill>();
    const [openRCAWithNoActionPlansModal, setOpenRCAWithNoActionPlansModal] = useState<boolean>(false);
    const argsFilters = useMemo(
        () => ({
            date: moment().subtract(Number(filters.periodOption), "day").startOf("day").toISOString(),
            divisionIds: filters.divisionIds,
            totalDivisions: filters.totalDivisions,
            regionIds: filters.regionIds,
            totalRegions: filters.totalRegions,
        }),
        [filters],
    );
    const { avgActionPlansPerMill } = RCACorporateDashboardEntity.GetAvgActionPlansPerMill(argsFilters);

    useEffect(() => {
        if (avgActionPlansPerMill && avgActionPlansPerMill.length > 0) {
            const sum = avgActionPlansPerMill.reduce((acc, m) => acc + Number(m.average_action_plans_per_rca), 0);
            setTotalAvg(sum / avgActionPlansPerMill.length);
            setTotalRcaWithZeroAP(avgActionPlansPerMill.reduce((acc, m) => acc + Number(m.rca_without_action_plans), 0));
        } else {
            setTotalAvg(0);
            setTotalRcaWithZeroAP(0);
        }
    }, [avgActionPlansPerMill]);

    return (
        <>
            <div className={classes.card}>
                <div className={classes.tableHeader}>
                    <Typography variant="rcaTitle" className={classes.cardTitle}>
                        {t("rca.compliance.rca_compliance.ap_per_rca.title")}
                    </Typography>
                </div>
                <table className={classes.table}>
                    {avgActionPlansPerMill.length > 0 ? (
                        <>
                            <thead>
                                <tr>
                                    <th className={classes.th}>{t("rca.corporate_dashboard.rca_compliance.mill")}</th>
                                    <th className={classes.th}>{t("rca.compliance.rca_compliance.ap_per_rca.avg")}</th>
                                    <th className={classes.th}>
                                        {t("rca.compliance.rca_compliance.ap_per_rca.rcaWithZeroAp")}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {avgActionPlansPerMill?.map((row) => (
                                    <tr key={row.mill_id}>
                                        <td className={classes.thTd}>
                                            <div className={classes.userNameContainer}>{row.name}</div>
                                        </td>
                                        <td className={classes.thTd}>{row.average_action_plans_per_rca}</td>
                                        <td
                                            onClick={() => {
                                                if (!row.rca_without_action_plans) return;
                                                setMillSelected(row);
                                                setOpenRCAWithNoActionPlansModal(true);
                                            }}
                                            className={
                                                row.rca_without_action_plans ? classes.thTdHighlighted : classes.thTd
                                            }
                                        >
                                            {row.rca_without_action_plans ?? "-"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td className={classes.tfootTd}>
                                        {t("rca.compliance.rca_compliance.ap_per_rca.total")}
                                    </td>
                                    <td className={classes.tfootTd}>{totalAvg}</td>
                                    <td className={classes.tfootTd}>{totalRcaWithZeroAP}</td>
                                </tr>
                            </tfoot>
                        </>
                    ) : (
                        <p className={classes.noData}>{t("rca.compliance.rca_compliance.ap_per_rca.noDataFound")}</p>
                    )}
                </table>
            </div>
            <RCAWithNoActionPlansByMillModal
                open={openRCAWithNoActionPlansModal}
                handleClose={() => setOpenRCAWithNoActionPlansModal(false)}
                data={millSelected}
            />
        </>
    );
};

export default RCAActionPlansPerMill;
